import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import Logo from "../components/Logo";
import LanguagePicker from "./header/LanguagePicker";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: "relative",
      height: "100%",
      overflow: "auto",
    },
    languagePicker:{
      position: "absolute",
      top: "0",
      right: "0"
    },
    home: {
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "300px",
      height: "auto",
      transform: "translate(-50%, -50%)",
      

      "@media only screen and (min-width: 1280px)": {
        width: "340px",
      },
      "@media only screen and (max-height: 700px)": {
        "&>div:first-child":{
          paddingTop:"2rem"
        },
      },

      "& h5": {
        margin: "0",
      },

      "& .link": {
        color: "#4F3CC9",
        textDecoration: "none",
      },

      "& .back": {
        display: "inline-flex",
        borderRadius: "5px",
        alignItems: "center",
        justifyContent: "center",
        alignSelf: "flex-start",
        textDecoration: "none",
      },

      "& .back-icon": {
        display: "inline-flex",
        border: "1px solid grey",
        borderRadius: "5px",
        alignItems: "center",
        justifyContent: "center",
        alignSelf: "flex-start",
        width: "2.4rem",
        height: "2.4rem",
      },

      "& .back-text": {
        paddingLeft: "1rem",
        fontSize: "1rem",
        color: "#757575",
        textDecoration: "none",
      },

      "& .forgotten": {
        marginTop: "-1rem",
        fontSize: "1rem",
        textAlign: "right",
      },

      "& h1": {
        fontSize: "1rem",
        textAlign: "center",
        color: "#212121",
      },

      "& .auth": {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "3rem",
        "@media only screen and (max-height: 700px)": {
          marginTop: "1rem",
        },

        "& .MuiInputBase-root": {
          backgroundColor: "#FFFFFF",
        },

        "& .MuiGrid-item":{
          position: "relative",
        },
        "& .additional": {
          display: "flex",
          flexDirection: "row",
          marginBottom: "1rem",

          "& > div": {
            flexGrow: "10",
            fontSize: "1rem",
          },

          "& > div:nth-of-type(2)": {
            textAlign: "right",

            "& .forgot": {
              color: "#8D98B7",
              cursor: "pointer",

              "&:hover": {
                textDecoration: "underline",
              },
            },
          },
        },

        "& .homeButtons": {
          margin: "2rem 0",

          "& > *": {
            width: "100%",
          },

          "@media only screen and (min-width: 1280px)": {
            position: "absolute",
            right: "-1.5rem",

            "& > *": {
              width: "auto",
            },

            "ui-label": {
              display: "none",
            },
          },
        },
      },

      "& .home-signup": {
        margin: "2rem 0",
        textAlign: "center",
        fontSize: "1rem",

        "& .not-member": {
          padding: "0 0.25rem",
          color: "#C1CAE1",
        },

        "& .signup": {
          padding: "0 0.25rem",
          color: "#8D98B7",
          cursor: "pointer",

          "&:hover": {
            textDecoration: "underline",
          },
        },
      },

      "& .home-logo": {
        width: "73px",
        height: "44px",
        backgroundImage: 'url("../assets/images/yoello-logo.svg")',
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        margin: "3rem auto 0",
      },

      "& .ui-textfield": {
        width: "100%",
        marginBottom: "1rem",
      },
      "& form .leftButton": {
        marginTop:"2rem"
      },

      "& .ui-button": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row-reverse",

        "& .ui-icon": {
          position: "static",
          transform: "scale(0.7)",
        },
      },
    },
  })
);

const HomeLayout = (props: any) => {
  const { t } = useTranslation();

  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <title>{t("misc.welcome")}</title>

      <div className={classes.languagePicker}>
        <LanguagePicker />
      </div>

      <div className={classes.home}>
        <Logo />

        <h1>{t("home.title")}</h1>

        <div className="auth">{props.children}</div>

        {navigator.cookieEnabled ? null : (
          <h5 style={{ color: "red" }}>
            Please enable cookies for your browser, or you may encounter
            difficulties with our site if third party cookies are disabled.
          </h5>
        )}
      </div>
    </div>
  );
};

export default HomeLayout;
